import { render, staticRenderFns } from "./invenDetail.vue?vue&type=template&id=4136c2be&scoped=true&"
import script from "./invenDetail.vue?vue&type=script&lang=js&"
export * from "./invenDetail.vue?vue&type=script&lang=js&"
import style0 from "./invenDetail.vue?vue&type=style&index=0&id=4136c2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136c2be",
  null
  
)

export default component.exports